import { DATE_FORMATS, DATE_RELATIVE_REGEXP_LIST, TIME_REGEXP_LIST, TIME_FORMAT, } from "../interfaces";
import { DateTime } from "luxon";
import Ajv from "ajv";
import { createFocusErrors } from "./utils";
import _ from "lodash";
export const validateFocusTimeHM = (dateString) => TIME_REGEXP_LIST[TIME_FORMAT.HM].test(dateString);
export const validateFocusTimeAHM = (dateString) => TIME_REGEXP_LIST[TIME_FORMAT.AHM].test(dateString);
export const validateFocusTimeHMS = (dateString) => TIME_REGEXP_LIST[TIME_FORMAT.HMS].test(dateString);
export const validateFocusTimeAHMS = (dateString) => TIME_REGEXP_LIST[TIME_FORMAT.AHMS].test(dateString);
export const validateDateTimeDay = (dateString) => {
    const date = DateTime.fromFormat(dateString, "yyyy/MM/dd");
    return date.isValid;
};
export const validateRelativeTimeDay = (dateString) => DATE_RELATIVE_REGEXP_LIST[DATE_FORMATS.DAY_REL].test(dateString);
export const validateDateTimeSecond = (dateString) => {
    const date = DateTime.fromFormat(dateString, "yyyy/MM/dd-HH:mm:ss");
    return date.isValid;
};
export const validateDateTimeSecondDot = (dateString) => {
    const date = DateTime.fromFormat(dateString, "yyyy/MM/dd-HH:mm:ss.");
    return date.isValid;
};
export const validateRelativeTimeSecondDot = (dateString) => DATE_RELATIVE_REGEXP_LIST[DATE_FORMATS.SEC_REL_DOT].test(dateString);
export const validateRelativeTimeSecond = (dateString) => DATE_RELATIVE_REGEXP_LIST[DATE_FORMATS.SEC_REL].test(dateString);
export const validateDateTime = (dateString) => {
    const date = DateTime.fromFormat(dateString, "yyyy/MM/dd-HH:mm:ss.SSS");
    return date.isValid;
};
export const validateRelativeTime = (dateString) => DATE_RELATIVE_REGEXP_LIST[DATE_FORMATS.STD_REL].test(dateString);
export const validateDateTimeMicro = (dateString) => {
    if (dateString.length !== "yyyy/MM/dd-HH:mm:ss.uuuuuu".length) {
        return false;
    }
    const dateMillis = dateString.slice(0, "yyyy/MM/dd-HH:mm:ss.uuuuuu".length - 3);
    const date = DateTime.fromFormat(dateMillis, "yyyy/MM/dd-HH:mm:ss.SSS");
    return date.isValid && /^(\d{3})$/.test(dateString.slice(-3));
};
export const validateRelativeTimeMicro = (dateString) => DATE_RELATIVE_REGEXP_LIST[DATE_FORMATS.MIC_REL].test(dateString);
export const ajv = new Ajv({ allErrors: true });
ajv.addMetaSchema(require("ajv/lib/refs/json-schema-draft-06.json"));
ajv.addFormat("focus-date-time-day", {
    validate: validateDateTimeDay,
});
ajv.addFormat("focus-date-time-second-dot", {
    validate: validateDateTimeSecondDot,
});
ajv.addFormat("focus-relative-time-second-dot", {
    validate: validateDateTimeSecondDot,
});
ajv.addFormat("focus-relative-time-day", {
    validate: validateRelativeTimeDay,
});
ajv.addFormat("focus-date-time-second", {
    validate: validateDateTimeSecond,
});
ajv.addFormat("focus-relative-time-second", {
    validate: validateRelativeTimeSecond,
});
ajv.addFormat("focus-date-time", {
    validate: validateDateTime,
});
ajv.addFormat("focus-relative-time", {
    validate: validateRelativeTime,
});
ajv.addFormat("focus-date-time-micro", {
    validate: validateDateTimeMicro,
});
ajv.addFormat("focus-relative-time-micro", {
    validate: validateRelativeTimeMicro,
});
ajv.addFormat("focus-time-hm", {
    validate: validateFocusTimeHM,
});
ajv.addFormat("focus-time-ahm", {
    validate: validateFocusTimeAHM,
});
ajv.addFormat("focus-time-hms", {
    validate: validateFocusTimeHMS,
});
ajv.addFormat("focus-time-ahms", {
    validate: validateFocusTimeAHMS,
});
ajv.addKeyword("rowMinimum", {
    errors: true,
    validate: evaluateLimits,
});
ajv.addKeyword("rowMaximum", {
    errors: true,
    validate: evaluateLimits,
});
ajv.addKeyword("columnMinimum", {
    errors: true,
    validate: evaluateLimits,
});
ajv.addKeyword("columnMaximum", {
    errors: true,
    validate: evaluateLimits,
});
export const validationAjv = (schema, data) => {
    let valid;
    let ajvExErrors;
    let noException = true;
    let ajvObj = {
        valid: null,
        errors: null,
    };
    try {
        valid = ajv.validate(schema, data);
    }
    catch (err) {
        noException = false;
        ajvExErrors = err.errors;
    }
    ajvObj.valid = valid;
    if (valid === false) {
        if (noException === true) {
            ajvObj.errors = createFocusErrors(ajv.errors);
        }
        else if (ajvExErrors) {
            ajvObj.errors = createFocusErrors(ajvExErrors);
        }
    }
    return ajvObj;
};
export function evaluateLimits(limitsValues, formData, schema, fieldLocation) {
    let key;
    let evaluationResult = true;
    let position;
    for (let prop in schema) {
        if (schema[prop] == limitsValues) {
            key = prop;
        }
    }
    const fieldArray = fieldLocation.split("[");
    if (fieldArray.length < 3) {
        position = fieldLocation.split("[")[1].slice(0, -1);
    }
    else {
        if (key === "rowMinimum" || key === "rowMaximum") {
            position = fieldLocation.split("[")[1].slice(0, -1);
        }
        else {
            position = fieldLocation.split("[")[2].slice(0, -1);
        }
    }
    const positionLimit = limitsValues[position];
    if ((key === "rowMinimum" || key === "columnMinimum") &&
        !isNaN(parseFloat(positionLimit))) {
        evaluationResult = formData >= positionLimit;
    }
    else if ((key === "rowMaximum" || key === "columnMaximum") &&
        !isNaN(parseFloat(positionLimit))) {
        evaluationResult = formData <= positionLimit;
    }
    if (!evaluationResult) {
        const limitCondition = key === "columnMinimum" || key === "rowMinimum" ? ">=" : "<=";
        evaluateLimits["errors"] = [];
        evaluateLimits["errors"].push({
            keyword: key,
            message: " value limited by " +
                key +
                ", should be " +
                limitCondition +
                " " +
                limitsValues[position] +
                ", but is " +
                formData,
            params: {
                keyword: key,
            },
        });
    }
    return evaluationResult;
}
export function getUnconditionalSchema(schema, data) {
    let newSchema = _.cloneDeep(schema);
    if (schema.if) {
        let isValid = false;
        try {
            isValid = ajv.validate(schema.if, data);
        }
        catch (e) {
            isValid = false;
        }
        const validSchema = isValid
            ? getUnconditionalSchema(schema.then, data)
            : getUnconditionalSchema(schema.else, data);
        newSchema = _.merge(newSchema, validSchema);
        delete newSchema.if;
        delete newSchema.then;
        delete newSchema.else;
    }
    return newSchema;
}
//# sourceMappingURL=validation.js.map